import { createFileRoute, redirect } from "@tanstack/react-router"

import { SettingsDevJwtPage } from "@/pages/settings/dev-jwt"

/** This route only exists in local Vite dev; production build has `import.meta.env.DEV === false`. */
export const Route = createFileRoute("/_authenticated/settings/dev/jwt")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: SettingsDevJwtPage,
})
